export const dessertsData = [
  {
    name: "Cornish - Mackerel",
    price: "$20.00",
    desc: "A small river named Duden flows by their place and supplies",
    id: "dessert1",
    imgPath: "assets/images/food/dessert-1.jpg.webp"
  },
  {
    name: "Roasted Steak",
    price: "$29.00",
    id: "dessert2",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/food/dessert-2.jpg.webp"
  },
  {
    name: "Seasonal Soup",
    price: "$20.00",
    id: "dessert3",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/food/dessert-3.jpg.webp"
  },
  {
    name: "Chicken Curry",
    price: "$20.00",
    id: "dessert4",
    desc: "A small river named Duden flows by their place and supplies",
    imgPath: "assets/images/food/dessert-4.jpg.webp"
  },
]
